let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("klKxD")).then(() => parcelRequire('9U9uL'));